/**
 * calendar.js
 * Create google calendar event link, or ics download link
 * event can have { title, description, start, end, duration, URL }
 *
 * start and end expected to be milliseconds from epoch
 * duration expected to be milliseconds
 *
 * Author - Alex McNerney
 * Copyright (c) 2018, Nanome Inc
 */

const formatTime = date => new Date(+date).toISOString().replace(/-|:|\.\d+/g, "")

const getEnd = event => {
  const end = event.end || +event.start + event.duration
  return formatTime(end)
}

const calendar = {
  google(event) {
    const start = formatTime(event.start)
    const end = getEnd(event)

    const url = [
      "https://www.google.com/calendar/render?action=TEMPLATE",
      `&text=${event.title || ""}`,
      `&details=${event.description || ""}`,
      `&dates=${start || ""}/${end || ""}`
    ].join("")

    return encodeURI(url)
  },

  ics(event) {
    const start = formatTime(event.start)
    const end = getEnd(event)

    const url =
      "data:text/calendar;charset=utf8," +
      [
        "BEGIN:VCALENDAR",
        "VERSION:2.0",
        "BEGIN:VEVENT",
        `URL:${event.url || ""}`,
        `DTSTART:${start || ""}`,
        `DTEND:${end || ""}`,
        `SUMMARY:${event.title || ""}`,
        `DESCRIPTION:${event.description || ""}`,
        "END:VEVENT",
        "END:VCALENDAR"
      ].join("\n")

    return encodeURI(url)
  }
}

export default calendar
